import { render, staticRenderFns } from "./IssueLabel.vue?vue&type=template&id=1730f318&scoped=true&"
import script from "./IssueLabel.vue?vue&type=script&lang=js&"
export * from "./IssueLabel.vue?vue&type=script&lang=js&"
import style0 from "./IssueLabel.vue?vue&type=style&index=0&id=1730f318&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1730f318",
  null
  
)

export default component.exports